import { Navigate, Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "../components/auth/ProtectedRoute";
import { LoginPage } from "../pages/auth/LoginPage";
import { SupportCompanyPage } from "../pages/suporte/SupportCompanyPage";
import { CourtesyPage } from "../pages/suporte/CourtesyPage";
import { SearchIndexPage } from "../pages/suporte/SearchIndexPage";
import { SupportHomePage } from "../pages/suporte/SupportHomePage";
import { TicketsPage } from "../pages/suporte/TicketsPage";

export function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/suporte"
        element={
          <ProtectedRoute>
            <SupportHomePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/suporte/chamados"
        element={
          <ProtectedRoute>
            <TicketsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/suporte/cortesia"
        element={
          <ProtectedRoute>
            <CourtesyPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/suporte/busca-mensagens"
        element={
          <ProtectedRoute>
            <SearchIndexPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/suporte/empresa/:companyId"
        element={
          <ProtectedRoute>
            <SupportCompanyPage />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/suporte" replace />} />
    </Routes>
  );
}
